<template>
  <button
    type="button"
    class="theme-toggle"
    :aria-label="label"
    :title="label"
    @click="toggleTheme"
  >
    <i class="fas" :class="isDarkTheme ? 'fa-sun' : 'fa-moon'" aria-hidden="true"></i>
    <span class="theme-toggle__text d-none d-md-inline">{{ label }}</span>
  </button>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ThemeToggleComponent",
  computed: {
    ...mapGetters("theme", ["isDarkTheme"]),
    label() {
      return this.isDarkTheme
        ? this.$t("pages.navigation.theme_light")
        : this.$t("pages.navigation.theme_dark");
    },
  },
  methods: {
    ...mapActions("theme", ["toggleTheme"]),
  },
};
</script>

<style lang="scss" scoped>
.theme-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--portal-border);
  border-radius: 10px;
  background: var(--portal-surface);
  color: var(--portal-text-muted);
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;

  &:hover {
    background: var(--portal-primary-soft);
    border-color: transparent;
    color: var(--portal-primary);
  }

  &:focus {
    outline: 2px solid var(--portal-ring);
    outline-offset: 2px;
  }

  i {
    font-size: 0.85rem;
  }
}
</style>
